import { fetchQuery, graphql, useRelayEnvironment } from 'react-relay';
import { useProductIsResizableFetchProductQuery } from './__generated__/useProductIsResizableFetchProductQuery.graphql';

const productIsResizableDetailQuery = graphql`
    query useProductIsResizableFetchProductQuery($id: ID!) {
        model(id: $id) {
            id
            modelID
            statusID
            name
            code
            salesChannelID
            options {
                optionID
                colorID
                sideID
                optionsData {
                    isResizable
                }
            }
        }
    }
`;

export const useProductIsResizable = () => {
    const environment = useRelayEnvironment();

    const isResizable = async (modelID: string) => {
        const result = await fetchQuery<useProductIsResizableFetchProductQuery>(
            environment,
            productIsResizableDetailQuery,
            { id: modelID },
            { fetchPolicy: 'store-or-network' }
        ).toPromise();

        if (!result) {
            return null;
        }

        return result.model && result.model.options.some((o) => o.optionsData.isResizable === true);
    };

    return {
        isResizable
    };
};
